export default __webpack_public_path__ + "static/media/social-proof.bff261c6.png";